import {
  Box, Button, Flex, Image,
} from '@chakra-ui/react';
import { useState } from 'react';

import ApplicantSection from './components/ApplicantSection';
import ApplicantTabs from './components/ApplicantTabs';
import { CreateApplicantModal } from './components/CreateApplicantModal';
import BackIcon from 'assets/icons/back.svg';
import { useModal } from 'hooks/useModal';
import { UploadFileModal } from 'pages/upload-file-page/UploadFileModal';

export default function ApplicantPage(): JSX.Element {
  const [addModal, addModalCtl] = useModal({});
  const [uploadModal, uploadModalCtl] = useModal({});

  return (
    <Box
      display='flex' alignItems='center'
      justifyContent='center'
    >
      <Box
        maxWidth='1100px' minW='350px'
        width='100%'
      >
        <Flex
          justify='flex-start' align='center'
          mb={4}
        >
          <Button
            backgroundColor='white'
            boxShadow='0px 17px 41px 0px #D9D9D9'
            color='white'
            w='56px'
            h='56px'
            mb='50px'
            borderRadius='15px'
            variant='link'
            onClick={() => window.history.back()}
          >
            <Image src={BackIcon} width='10px' />
          </Button>
        </Flex>

        <Flex
          justify='space-between' align='flex-start'
          mb={6}
        >
          <Box flex='1'>
            <ApplicantTabs onAdd={addModalCtl.onOpen} />
          </Box>

          <Button onClick={uploadModalCtl.onOpen}>Upload file</Button>
        </Flex>
        <ApplicantSection />
        <CreateApplicantModal
          isOpen={addModal.isOpen}
          onClose={addModalCtl.onClose}
        />
        <UploadFileModal
          isOpen={uploadModal.isOpen}
          onClose={uploadModalCtl.onClose}
        />
      </Box>
    </Box>
  );
}
